// components/EndpointDoc.jsx
import React from 'react'
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody, styled,
} from '@mui/material'
import ApiExamplesView from './ApiExamplesView'

const SectionHeader = styled(Typography)(({ theme }) => ({
  fontWeight: 'bolder',
  color: theme.palette.blues.rothko2,
  fontSize: 'medium'
}));

const SectionText = styled(Typography)(({ theme }) => ({
  color: theme.palette.base.rothko4,
  fontSize: 'small',
  marginBottom: '24px',
}));

/** Renders a simple name|type|options|description table */
const ParamTable = ({ params }) => (
  <Table size="small"
         sx={{
           tableLayout: 'fixed',
           marginBottom: '24px',
         }}>
    <TableHead>
      <TableRow>
        <TableCell sx={{ width: 'auto' }}><strong>NAME</strong></TableCell>
        <TableCell sx={{ width: 'auto' }}><strong>TYPE</strong></TableCell>
        <TableCell sx={{ width: 'auto' }}><strong>OPTIONS</strong></TableCell>
        <TableCell sx={{ width: '40%' }}><strong>DESCRIPTION</strong></TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {params.map(({ name, type, options, description }) => (
        <TableRow key={name}>
          <TableCell sx={{fontFamily: 'monospace'}}>{name}</TableCell>
          <TableCell sx={{fontFamily: 'monospace'}} >{type}</TableCell>
          <TableCell sx={{fontFamily: 'monospace'}}>{options ?? '—'}</TableCell>
          <TableCell sx={{fontSize: 'x-small'}}>{description}</TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
)

const ApiEndpointInstance = ({
  method,
  path,
  description,
  notes,
  pathParams = [],
  queryParams = [],
  examples = [],
}) => (
  <Box sx={{ p: { xs: 2, sm: 3 } }}>

    <Typography gutterBottom fontSize={{xs: 'medium', sm: 'large'}}>
      <Box
        component="span"
        sx={{
          fontFamily: 'Monospace',
          fontWeight: 'bold',
          mr: 1,
          color: method.toUpperCase() === 'GET' ? 'green' : 'goldenrod',
      }}
      >
        {method.toUpperCase()}
      </Box>
      <Box component="span" sx={{ fontFamily: 'Monospace' }}>
        {path}
      </Box>
    </Typography>

    {description && (
      <SectionText dangerouslySetInnerHTML={{ __html: description }} />
    )}

    {notes && (
      <>
        <SectionHeader>NOTES</SectionHeader>
        <SectionText dangerouslySetInnerHTML={{ __html: notes }} />
      </>
    )}

    {pathParams.length > 0 && (
      <>
        <SectionHeader>PATH PARAMETERS</SectionHeader>
        <ParamTable params={pathParams} />
      </>
    )}

    {queryParams.length > 0 && (
      <>
        <SectionHeader>QUERY PARAMETERS</SectionHeader>
        <ParamTable params={queryParams} />
      </>
    )}

    {examples.length > 0 && (
      <>
        <SectionHeader>EXAMPLES</SectionHeader>
        <ApiExamplesView examples={examples} />
      </>
    )}
  </Box>
)

export default ApiEndpointInstance
